<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HCRLyR/tc-custom/9781398430921.jpg?1705688300247" alt="This image is the cover for the book Pieces of a Larger Mirror"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pieces of a Larger Mirror
      </h1>
      <p class="bookDescription body article font2">
        <p>“If anyone believes they are religious and does not bridle their tongue but deceives their own heart, this person’s religion is worthless.” James 1:26 Not to be read in isolation, or necessarily in order, walk side by side with the narrator as she opens up on issues of childhood experience and race, upbringing and relationships, schooling and culture through a unique lens intended to be merely the beginning of your journey upward, outward, inward. Are you ready to look into the mirror?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Abigail Smith-Buckle
      </h2>
      
      <p class="authorDescription body article">Abigail Smith-Buckle is a musician from Greater London. This work began to be written at the age of 18; more is available on music platforms.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?59e9edc0